export enum PresentOnAdmission {
  Y = 'Yes',
  N = 'No',
  U = 'Unknown',
  W = 'Clinically undetermined',
  I = 'Unreported/Not Used (Exempt from POA reporting)',
}
